import React from 'react'
import './All_video.css'
import Heading_title from '../../common-components/common-title/heading-title/Heading_title'

const All_video = () => {
    return (
        <>
            <section className='all_vdo_sec'>
                <div className='container'>
                    <Heading_title title="Our Videos" subtitle="Videos of Our Products" />
                    <div className='row mt-4'>
                         <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/new-machine.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/currency_counting_machine.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/gold-testing.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/Sanitary_pad_vending_machine.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/Scound_video_coin_sorting_machine.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/sorting_machine_cassida.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/vdo6.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-6  mb-4 '>
                            <div className='vdodiv'>
                                <video className='vdo' controls >
                                    <source src={process.env.PUBLIC_URL + '/assets/videos/all-machines/new.mp4'} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default All_video